import React from 'react';
// import {useContext} from 'react';
// //import "./style.css";
// import { Link } from 'react-router-dom';

import Header   from '../../components/Header';
import Footer   from '../../components/MFooter'
// import Loading   from '../../components/Loading'

import './duvidas.css'

function App() {

    return (<div>
      {/* menu superior do dj */}
      <Header/>

      {/* Conteudo */}
      <div className='dj-flex-center-v'>
        <Corpo
                titulo="Não esquenta!"
                texto="Você pode entrar em contato pelo:"
            />
        </div>
        <Footer/>
    </div>);

};

export default App;

function Corpo(props) {
  const { titulo, texto } = props;

  return (
    <div className="duvida-corpo">
      <h1 className="duvida-titulo">{titulo}</h1>
      <div className="duvida-h2">{texto}</div>
      <div className="duvida-blocos">
        {/* <Bloco
          texto={blocoData_zap_inova.texto}
          texto2={blocoData_zap_inova.texto2}
          icone={blocoData_zap_inova.icone}
          to={blocoData_zap_inova.to}
        /> */}
        {/* <div className="duvida-ou">ou</div> */}
        <Bloco
          texto={blocoData_zap_ed.texto}
          texto2={blocoData_zap_ed.texto2}
          icone={blocoData_zap_ed.icone}
          to={blocoData_zap_ed.to}
        />
        <div className="duvida-ou">ou</div>
        <Bloco
          texto={blocoData_mail.texto}
          texto2={blocoData_mail.texto2}
          icone={blocoData_mail.icone}
          to={blocoData_mail.to}
        />
        {/* <div className="duvida-ou">ou</div>
        <Bloco
          texto={blocoData_manual.texto}
          texto2={blocoData_manual.texto2}
          icone={blocoData_manual.icone}
          to={blocoData_manual.to}
        /> */}
      </div>
    </div>
  );
}


function Bloco(props) {
  const {
      texto,
      texto2,
      icone,
      to,
   } = props;

  return (
    <div className="duvida-bloco">
      <div className="duvida-bloco-textos">
        <div className="duvida-bloco-texto">{texto}</div>
        <div className="duvida-bloco-dados">
            <p className="duvida-bloco-texto2">{texto2}</p>
             <a href={to} target="_blank" rel="noreferrer">
                 <img alt='' className="duvida-bloco-icone" src={icone} />
             </a>
        </div>
        <div className="duvida-bloco-texto2 duvida-bloco-info ">Copie ou clique no ícone acima</div>
      </div>
    </div>
  );
}

// const blocoData_zap_inova = {
//     texto: "WhatsApp do Inova Maranhão",
//     texto2: "+55 (98) 99129-6071",
//     to:`https://wa.me/5598991296071/?text=Oi,%20vim%20pela%20plataforma`,
//     icone: "/img/ico-whatsapp@2x.png",
// };
const blocoData_zap_ed = {
    texto: "WhatsApp do Robô ED",
    texto2: "+55 (98) 99185-6577",
    to:`https://wa.me/5598991856577/?text=Oi%20Ed,%20vim%20pela%20plataforma`,
    icone: "/img/ico-whatsapp@2x.png",
};

const blocoData_mail = {
    texto: "E-mail",
    texto2: "inovamaranhao.educa@gmail.com",
    to:"mailto:inovamaranhao.educa@gmail.com",
    icone: "/img/ico-email@2x.png",
};

// const blocoData_manual = {
//     texto: "Manual de uso da plataforma",
//     texto2: "inovonline.vercel.app/manual",
//     to:"inovonline.vercel.app/manual",
//     icone: "/img/ico-email@2x.png",
// };

// https://anima-uploads.s3.amazonaws.com/projects/5ff7c137a976a64adc4f9477
